import { render, staticRenderFns } from "./ContMyDashboardsComponent.vue?vue&type=template&id=7c8988d0&scoped=true&lang=pug"
import script from "./ContMyDashboardsComponent.vue?vue&type=script&lang=js"
export * from "./ContMyDashboardsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8988d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8988d0')) {
      api.createRecord('7c8988d0', component.options)
    } else {
      api.reload('7c8988d0', component.options)
    }
    module.hot.accept("./ContMyDashboardsComponent.vue?vue&type=template&id=7c8988d0&scoped=true&lang=pug", function () {
      api.rerender('7c8988d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyDashboardsComponent.vue"
export default component.exports